import routes, { toLoginUrl } from "../routes";
import { SUBSCRIPTION } from "../purchaseTypes";

const savePriceItem = ({ planCode, seats, price }) => ({
	storageService,
	authService,
	routingService,
}) => {
	storageService.priceItem.write({
		planCode,
		seats,
		price,
		purchaseType: SUBSCRIPTION,
	});

	routingService.push(
		authService.isAuthorized() ? routes.billingInfo : toLoginUrl({ returnUrl: routes.billingInfo }),
	);
};

export default savePriceItem;
